<template>
    <div class="post-container">
        <div class="post-body">
            <div class="post-text">
                <div class="post-title">
                    {{data.title}}
                </div>
                <div class="post-synopsis">
                    {{data.synopsis}}
                </div>
            </div>
            <image-view v-if="data.image && !imageHidden"
                        class="post-image"
                        size="post"
                        :url="data.image"/>
            <div class="post-footer">
                <div>{{formattedDate}}</div>
                <router-link v-if="!!data.link"
                             :to="data.link"
                             class="flat-button btn-read-more">
                    {{this.$lang.postReadMore}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
	import ImageView from "@/components/ImageView";

	export default {
		name: "Post",
		components: {ImageView},
		props: {
			data: {
				type: Object,
				required: true
			},
			imageHidden: {
				type: Boolean,
				required: false
			},
			showDate: {
				type: Boolean,
				required: false
			}
		},
		methods: {
			zeroPad(num) {
				return num < 10 ? "0" + String(num) : String(num);
			}
		},
		computed: {
			formattedDate() {
				let d = new Date(this.data.date);
				let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
					"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
				return `${this.zeroPad(d.getHours())}:${this.zeroPad(d.getMinutes())} `
					+ `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
			}
		}
	}
</script>

<style scoped lang="scss">

    .post-container {
        position: relative;
        display: flex;
        flex-flow: row nowrap;
        animation: show-post 0.5s $bezier;
        border: $solid;
        padding: 32px;
        @extend %card;
    }

    @keyframes show-post {
        from {
            transform: translateY(2em);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .post-body {
        display: flex;
        flex-flow: column nowrap;
        padding: 0;
        flex-grow: 1;
        text-align: left;
        width: 100%;
    }

    .post-image {
        object-fit: cover;
        width: calc(100% - 8px);
        margin: 8px 0;
        box-shadow: $p-accent 8px 8px 0 0;
        background-color: $s-accent;

        @media #{tablet} {
            //noinspection CssInvalidPropertyValue
            max-height: calc(min(1200px, 90vw) * 0.6);
        }

        @media #{tablet-inv} {
            //noinspection CssInvalidPropertyValue
            max-height: calc(min(1200px, 90vw) * 0.42);
        }
    }

    @media #{$tablet} {
        img:not(.raster) {
            display: none;
        }
    }

    .post-text {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
    }

    .post-title {
        font-size: 24px;
        line-height: 24px;
        font-family: $serif;
        margin-bottom: 12px;
    }

    .post-footer {
        display: flex;
        flex-direction: row;
        margin-top: 8px;
    }

    .post-footer > div {
        flex-grow: 1;
        color: $d-fg;
    }

    .btn-read-more {
        display: inline-block;
        color: $s-accent;
        align-self: flex-end;
    }

    img + .btn-read-more {
        margin-top: 16px;
    }
</style>